<template>
  <div
    v-if="value"
    ref="modal"
    class="gl-modal"
    @click="closeOnClickaway($event)"
  >
    <div
      class="gl-modal__container"
      :class="[{'gl-modal__container--overflow': overflowing}]"
      :style="[{ width: isMobile ? '95vw' : `${width}${ticker}` }]"
    >
      <div
        v-if="loading"
        class="flex align-center justify-center modal-loader"
      >
        <gl-loader />
      </div>
      <div
        class="gl-modal__group"
        :class="[{'gl-modal__container--loading': loading}]"
      >
        <div
          v-if="title"
          class="gl-modal__title-wrapper"
        >
          <div 
            v-if="$slots.customHeader"
            class="gl-modal__custom-header"
          >
            <slot name="customHeader" />
          </div>
          <h2
            v-else
            class="gl-modal__title"
            :class="{ 'gl-modal__title--capitalize': capitalizeTitle }"
          >
            {{ title }}
          </h2>
          <div v-if="closableTop">
            <gl-icon
              class="pointer"
              :height="16"
              :hover="false"
              name="close"
              :width="16"
              @click="close"
            />
          </div>
        </div>
        <gl-form
          v-if="!infoOnly"
          v-bind="$attrs"
          :cancel-title="cancelTitle"
          :critical-submit="criticalSubmit"
          :disabled-submit="disabledSubmit"
          :full-buttons="fullButtons"
          :full-submit="fullSubmit"
          :loading="loading"
          :max-height="maxHeightForm"
          :ok-only="okOnly"
          :overflowing-form="overflowingForm"
          :side-valid="sideValid"
          :submit-title="submitTitle"
          :to-end="toEndButtons"
          @cancel="close"
          @submit="$emit('submit')"
        >
          <template
            v-if="$slots['actions-prefix']"
            #actions-prefix
          >
            <slot name="actions-prefix" />
          </template>
          <template #default="{ validate }">
            <slot :validate="validate" />
          </template>
        </gl-form>
      </div>
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import GlForm from '@/components/gl-form'
import GlLoader from '@/components/gl-loader'
import GlIcon from '@/components/gl-icon'
//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'
// Utils
import { pushEscHandler, removeEscHandler } from '@/utils/modal-esc-stack'

export default {
  components: {
    GlForm,
    GlLoader,
    GlIcon
  },
  mixins: [deviceWidthMixin],
  inheritAttrs: false,
  props: {
    submitTitle: {
      type: String,
      default: 'Submit',
    },
    closable: {
      type: Boolean,
      default: false,
    },
    toEndButtons: {
      type: Boolean,
      default: false,
    },
    okOnly: {
      type: Boolean,
      default: false,
    },
    sideValid: {
      type: Boolean,
      default: false
    },
    cancelTitle: {
      type: String,
      default: 'Cancel',
    },
    overflowing: {
      type: Boolean,
      default: false
    },
    overflowingForm: {
      type: Boolean,
      default: false
    },
    capitalizeTitle: {
      type: Boolean,
      default: false,
    },
    fullSubmit: {
      type: Boolean,
      default: false,
    },
    fullButtons: {
      type: Boolean,
      default: false,
    },
    infoOnly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '500'
    },
    maxHeightForm: {
      type: String,
      default: '50vh'
    },
    ticker: {
      type: String,
      default: 'px'
    },
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabledSubmit: {
      type: Boolean,
      default: false,
    },
    closableTop: {
      type: Boolean,
      default: false,
    },
    criticalSubmit: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    // The root is v-if'd on `value` while the component itself often stays
    // mounted, so the open/closed signal is the prop, not the lifecycle.
    value: {
      immediate: true,
      handler(isOpen) {
        if (isOpen) this.registerEsc()
        else this.unregisterEsc()
      },
    },
  },
  beforeDestroy() {
    // Most parents wrap the modal in v-if and destroy it while `value` is
    // still true, so the watcher never gets to clean up.
    this.unregisterEsc()
  },
  methods: {
    // Not gated on `closable`, unlike click-away: Escape emits the very event
    // the Cancel button emits, and every modal in the app is already
    // dismissible by Cancel, the header cross or a backdrop click. A parent
    // that ignores `close` simply stays open.
    registerEsc() {
      pushEscHandler(this.close)
    },
    unregisterEsc() {
      removeEscHandler(this.close)
    },
    close() {
      // this.$emit('input', false)
      this.$emit('close')
    },
    closeOnClickaway(e) {
      if (this.closable && e.target === this.$refs.modal) this.close()
    },
  },
}
</script>
